import Modal from "./modal/Modal";
import LoadingIcon from "./LoadingIcon"
import "./styles/Loader.css";

interface Props {
  isVisible: boolean | undefined;
}

export default function Loader(props: Props) {
  const { isVisible } = props;
  return (
    <>
      {isVisible && (
        <Modal
          visible={isVisible}
          shadingColor="transparent"
          displayDefaultActions={false}
          width="auto"
          height="150"
          className="promineo-loader"
          animation={{
            show: { duration: 0 },
            hide: { duration: 0 },
          }}
        >
          <div className="flex justify-center items-center p-6">
            <LoadingIcon/>
          </div>
        </Modal>
      )}
    </>
  );
}
